import { devtoolsSetPreserveLogs } from '../../../store/devTools/actions';
import Back from '../Back';
import Content from '../Content';
import styles from './Logs.module.scss';
import { useEffect } from 'react';
import ReactJson from 'react-json-view';
import { useDispatch, useSelector } from 'react-redux';

const Logs = () => {
  const logs = useSelector((state) => state.devTools.logs);
  const extensions = useSelector((state) => state.devTools.extensions);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(devtoolsSetPreserveLogs(true));

    return () => {
      dispatch(devtoolsSetPreserveLogs(false));
    };
  }, [dispatch]);

  return (
    <>
      <Back title="Logs" />

      <Content>
        <div className={styles.logs}>
          {logs.map((log) => (
            <div className={styles.block} key={log.key}>
              <ReactJson src={log.value} collapsed={1} theme="tomorrow" />
            </div>
          ))}

          <ReactJson src={extensions} collapsed={1} theme="tomorrow" name="extensions" />
        </div>
      </Content>
    </>
  );
};

export default Logs;
